/**
 * Use Case: Login
 * Business logic for user login
 */

import type { LoginCredentials, LoginResult } from "../model/AuthModel";
import type { IAuthRepository } from "../repository/IAuthRepository";
import { container, TYPES } from "../../di/AuthModule";

export const LoginUseCase = async (
  credentials: LoginCredentials
): Promise<LoginResult> => {
  const repository = container.get<IAuthRepository>(TYPES.IAuthRepository);
  return repository.login(credentials);
};

